export const isLocal = () => window?.location.hostname.includes("localhost");
